import { responsiveClassNames, responsiveVariables } from "../../utilities/props.js";
import s from "./minWidth.module.css";
const getMinWidthStyles = (value) => {
    if (!value)
        return null;
    const variables = responsiveVariables("--rs-min-w", value);
    const classNames = responsiveClassNames(s, (value) => (typeof value === "number" ? "--type-unit" : "--type-literal"), value, { excludeValueFromClassName: true });
    return { classNames: [s.root, classNames], variables };
};
export default getMinWidthStyles;
